import { ConnectionActionTypes, ConnectionStateType, ConnectionStatusType, SET_CONNECTION_STATUS } from "./types";
import { createReducer } from "@reduxjs/toolkit";
import { setConnectionStatus } from "./actions";

const initialState: ConnectionStateType = {
  connectionStatus: ConnectionStatusType.DISCONNECTED,
};

export const connectionReducer = createReducer(initialState, (builder) => {
  builder.addCase(setConnectionStatus, (state, action) => {
    state.connectionStatus = action.payload;
  });
});
